import { FC } from 'react'
import { OwnerSummaryOverview } from 'src/v2/views/owner-reveal/insights/owner-summary/owner-summary'
import { List } from '@emotion-icons/fluentui-system-regular/List'
import { InsightContainer } from 'src/v2/views/owner-reveal/insights/container'
import { PropertyValuationOvertime } from 'src/v2/views/owner-reveal/insights/owner-summary/property-valuation-overtime'
import { AcquisitionsOverviewGraphCard } from 'src/v2/views/owner-reveal/insights/owner-summary/acquisitions-overview-graph'
import { ActivityHeatmap } from 'src/v2/views/owner-reveal/insights/owner-summary/activity-heatmap'
import { isFeatureEnabled } from 'src/utils/feature-flag'
import { COMMANDAI_IDS_MAP } from 'src/constants/command-ai-ids'
import { InsightComponentProps, Insight } from 'src/components/insights/types'
import { Colors } from 'src/components/theme'

const OwnerSummaryContent: FC<InsightComponentProps> = ({ insight }) => {
  const isOwnerRevealMockDataEnabled = isFeatureEnabled('owner-reveal-mock-data')

  return (
    <InsightContainer insight={insight} color={Colors.primaryRed700} iconBgColor={Colors.primaryRed50}>
      <OwnerSummaryOverview />
      <AcquisitionsOverviewGraphCard />
      <ActivityHeatmap />
      {isOwnerRevealMockDataEnabled && <PropertyValuationOvertime />}
    </InsightContainer>
  )
}

export const OwnerSummary: Insight = {
  id: 'owner-summary',
  tabId: COMMANDAI_IDS_MAP.ownerReveal['entity-owner-summary-insights-tab'],
  component: OwnerSummaryContent,
  name: 'Owner Summary',
  icon: List,
  linkTooltipFile: 'owner-summary',
  supportedResultTypes: ['owner', 'parcel'],
}
